import React, { useEffect, useState } from "react";
import "./looking-loan.css";
import { FaMoneyBillWave, FaBolt, FaGlobe, FaLock } from "react-icons/fa";

// Fully generic placeholder info for automation
const genericInfo = [
  { limit: "Check your instant limit", apr: "Flexible options available", repay: "Manage your loan easily", status: "Ready to proceed" },
  { limit: "View your available funds", apr: "Tailored just for you", repay: "Simple steps to manage", status: "Instantly accessible" },
  { limit: "Your personalized limit", apr: "Smart lending options", repay: "Convenient terms", status: "Funds ready" },
  { limit: "See what you can borrow", apr: "Easy & hassle-free", repay: "Flexible repayment", status: "Ready anytime" },
];

const LookingLoan = () => {
  const [currentInfo, setCurrentInfo] = useState(genericInfo[0]);

  // Cycle through generic info every 4 seconds
  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentInfo(prev => {
        const currentIndex = genericInfo.indexOf(prev);
        const nextIndex = (currentIndex + 1) % genericInfo.length;
        return genericInfo[nextIndex];
      });
    }, 4000);
    return () => clearInterval(interval);
  }, []);

  // Glow animation for approval
  useEffect(() => {
    const glowInterval = setInterval(() => {
      const el = document.querySelector(".loan-approved");
      if (el) {
        el.classList.add("glow-approve");
        setTimeout(() => el.classList.remove("glow-approve"), 1200);
      }
    }, 4000);
    return () => clearInterval(glowInterval);
  }, []);

  return (
    <section className="ll-wrap">
      <div className="ll-container">
        {/* LEFT SIDE */}
        <div className="ll-left">
          <div className="ll-eyebrow">Looking for a Loan?</div>
          <h1 className="ll-title">
            Get <span className="ll-highlight">Instant Cash</span> in Minutes.
          </h1>
          <p className="ll-sub">
            Apply now and get quick approval for your short-term payday loan. No long forms, no stress — 
            just smart, instant lending tailored for your needs.
          </p>

          <div className="ll-cta-row">
            <button className="ll-btn-primary">Apply Instantly</button>
            <button className="ll-btn-ghost">Check Eligibility</button>
          </div>

          <div className="ll-trust">
  <div className="ll-trust-item">
    <FaMoneyBillWave className="trust-icon" />
    <span>No Hidden Fees</span>
  </div>
  <div className="ll-trust-item">
    <FaBolt className="trust-icon" />
    <span>Instant Disbursement</span>
  </div>
  <div className="ll-trust-item">
    <FaGlobe className="trust-icon" />
    <span>100% Online Process</span>
  </div>
  <div className="ll-trust-item">
    <FaLock className="trust-icon" />
    <span>Secure & Safe</span>
  </div>
</div>
        </div>

        {/* RIGHT SIDE: 3D Phone */}
        <div className="ll-right">
          <div className="ll-phone-3d">
            <div className="phone-glow"></div>
            <div className="phone-frame">
              <div className="phone-notch"></div>
              <div className="phone-ui">
                <div className="ui-header">
                  <span className="ui-title">Loanonsalary</span>
                  <span className="ui-status">🟢 Active</span>
                </div>

                <div className="ui-balance-box">
                  <p className="ui-label">Your Instant Limit</p>
                  <h2 className="ui-amount">{currentInfo.limit}</h2>
                  <div className="ui-progress">
                    <div className="ui-progress-bar"></div>
                  </div>
                  <p className="loan-approved">{currentInfo.status}</p>
                </div>

                <div className="ui-stats">
                  <div className="stat-item">
                    <p>Options</p>
                    <h4>{currentInfo.apr}</h4>
                  </div>
                  <div className="stat-item">
                    <p>Manage</p>
                    <h4>{currentInfo.repay}</h4>
                  </div>
                </div>

                <button className="ui-apply-btn">Proceed Now</button>
                <div className="ui-footer">All actions are safe & simple</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default LookingLoan;
